import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/bank/auth/:companyUuid/:appid/:key",
      name: "auth",
      component: () => import("./views/auth.vue"),
      meta: {
        title: "身份验证"
      }
    },
    {
      path: "/bank/applyList",
      name: "applyList",
      component: () => import("./views/applyList.vue"),
      meta: {
        title: "贷款列表"
      }
    },
    {
      path: "/bank/applyDetail",
      name: "applyDetail",
      component: () => import("./views/applyDetail.vue"),
      meta: {
        title: "贷款详情"
      }
    },

    {
      path: "/bank/applyPreview",
      name: "applyPreview",
      component: () => import("./views/applyPreviews.vue"),
      meta: {
        title: "预览文件"
      }
    },

    {
      path: "/customer/login/:companyUuid/:appid/:key",
      name: "customerLogin",
      component: () => import("./views/customer/login.vue"),
      meta: {
        title: "登录"
      }
    },

    {
      path: "/customer/transferList",
      name: "customerTransferList",
      component: () => import("./views/customer/transferList.vue"),
      meta: {
        title: "交易信息列表"
      }
    },
    {
      path: "/customer/transferDetail",
      name: "customerTransferDetail",
      component: () => import("./views/customer/transferDetail.vue"),
      meta: {
        title: "交易信息详情"
      }
    },

    {
      path: "/customer/comment",
      name: "comment",
      component: () => import("./views/customer/comment.vue"),
      meta: {
        title: "评论"
      }
    }
  ]
});
